(function () {
  function formatMoney(cents) {
    var format = window.shopMoneyFormat || '{{amount}} EUR';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return cents;

    function withDelimiters(number, precision, thousands, decimalSep) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimals = parts[1] ? decimalSep + parts[1] : '';
      return dollars + decimals;
    }

    var value;
    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function applySaleBadges() {
    var map = window.SaleCompareAtPrices;
    if (!map) return;
    var rows = document.querySelectorAll('[data-variant-id]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var variantId = row.getAttribute('data-variant-id');
      var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
      var compareCents = map[variantId];
      var priceCell = row.querySelector('.line-price');
      if (!priceCell) continue;
      var existing = priceCell.querySelector('.sale-compare-price');
      var stateKey = variantId + ':' + qty;
      if (!compareCents) {
        if (existing) existing.remove();
        priceCell.classList.remove('has-sale-compare');
        continue;
      }
      var lineTotal = compareCents * qty;
      priceCell.classList.add('has-sale-compare');
      if (existing) {
        if (existing.getAttribute('data-state') !== stateKey) {
          var small = existing.querySelector('small');
          if (small) small.textContent = formatMoney(lineTotal);
          existing.setAttribute('data-state', stateKey);
        }
        continue;
      }
      var el = document.createElement('s');
      el.className = 'old-price sale-compare-price';
      el.setAttribute('data-state', stateKey);
      var smallEl = document.createElement('small');
      smallEl.textContent = formatMoney(lineTotal);
      el.appendChild(smallEl);
      priceCell.insertBefore(el, priceCell.firstChild);
    }
  }

  function init() {
    applySaleBadges();
    var targets = document.querySelectorAll('[data-cart-view]');
    if (window.MutationObserver && targets.length) {
      var observer = new MutationObserver(function () {
        applySaleBadges();
      });
      for (var i = 0; i < targets.length; i++) {
        observer.observe(targets[i], { childList: true, subtree: true, attributes: true, attributeFilter: ['data-qty', 'data-variant-id'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', applySaleBadges);
  window.applySaleBadges = applySaleBadges;
})();
